import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useFormikContext } from 'formik';
import { useSearchableMenu } from 'shared/domains/common-ui/SearchableMenu';
export function ListSelectionAddItem(props) {
    const { items, onAdd } = props;
    const { submitForm } = useFormikContext();
    const { searchString } = useSearchableMenu();
    const hasExactMatch = searchString.length === 0 ||
        items.some((item) => item.value.toLocaleLowerCase() === searchString.toLocaleLowerCase());
    const handleAdd = () => {
        onAdd(searchString);
        return submitForm();
    };
    if (hasExactMatch) {
        return null;
    }
    return (<Menu.Item onClick={handleAdd}>
      <Falcon icon="plus"/>
      <Trans comment="Metadata: Add new value - No search result">Add {searchString}</Trans>
    </Menu.Item>);
}
